"use client";

import { useEffect, useState } from "react";
import { CarouselData, RecursiveTranslations } from "@/data/types";
import useEmblaCarousel from "embla-carousel-react";
import Link from "next/link";
import { SystemLanguages } from "@/data/enums";
import CarouselControls from "./CarouselControls";
import DeveloperCard from "./DeveloperCard";
import DefaultCard from "./DefaultCard";
import NoData from "@/components/skeleton/NoData";

interface DeveloperInfo {
  logo: string;
  brochure_url?: string
}

interface CarouselProps {
  lang?: SystemLanguages;
  translations?: RecursiveTranslations;
  data: CarouselData[];
  developer?: DeveloperInfo;
  noDataTitle?: string 
}

export default function Carousel({ lang, translations, data, developer }: CarouselProps) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, align: "center" });
  const [progress, setProgress] = useState(0);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const scrollPrev = () => emblaApi?.scrollPrev();
  const scrollNext = () => emblaApi?.scrollNext();

  useEffect(() => {
    if (!emblaApi) return;

    const updateProgress = () => {
      const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
      setProgress(progress * 100);
      setCanScrollPrev(emblaApi.canScrollPrev());
      setCanScrollNext(emblaApi.canScrollNext());
    };

    emblaApi.on("scroll", updateProgress);
    emblaApi.on("reInit", updateProgress);

    updateProgress();
  }, [emblaApi]);

  return (
    <>
      {(!data || data.length === 0) ? (<NoData />) : (
        <>
          {/* Carousel */}
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex gap-[15px]">
              {developer && (
                <DeveloperCard
                  translations={translations as RecursiveTranslations}
                  logo={developer.logo}
                  brochure_url={developer?.brochure_url}
                />
              )}

              {data.map((d, idx) => {
                return d.slug ? (
                  <Link
                    key={idx}
                    href={`/${lang}/projects/${d.slug}`}
                    className="cursor-pointer hover:opacity-90 transition duration-300"
                    aria-label="card-link"
                  >
                    <DefaultCard
                      labels={d?.labels}
                      title={d?.title}
                      subtitle={d?.subtitle}
                      caption={d?.caption}
                      image={d?.image}
                    />
                  </Link>
                ) : (
                  <DefaultCard
                    key={idx}
                    labels={d?.labels}
                    title={d?.title}
                    subtitle={d?.subtitle}
                    caption={d?.caption}
                    image={d?.image}
                  />
                );
              })}
            </div>
          </div>

          {/* Controls */}
          <CarouselControls
            progress={progress}
            canScrollPrev={canScrollPrev}
            canScrollNext={canScrollNext}
            scrollPrev={scrollPrev}
            scrollNext={scrollNext}
          />
        </>
      )}

    </>
  )

  // return (
  //   <>
  //     {/* Carousel */}
  //     <div className="overflow-hidden" ref={emblaRef}>
  //       <div className="flex gap-[15px]">
  //         {developer && (
  //           <DeveloperCard translations={translations as RecursiveTranslations} logo={developer.logo} brochure_url={developer?.brochure_url} />
  //         )}

  //         {data.map((d, idx) => {
  //           return d.slug ? (
  //             <Link key={idx} href={`/${lang}/projects/${d.slug}`} className="cursor-pointer hover:opacity-90 transition duration-300" aria-label="card-link">
  //               <DefaultCard labels={d?.labels} title={d?.title} subtitle={d?.subtitle} caption={d?.caption} image={d?.image} />
  //             </Link>
  //           ) : (
  //             <DefaultCard key={idx} labels={d?.labels} title={d?.title} subtitle={d?.subtitle} caption={d?.caption} image={d?.image} />
  //           );
  //         })}
  //       </div>
  //     </div>

  //     {/* Controls */}
  //     <CarouselControls 
  //       progress={progress} canScrollPrev={canScrollPrev} canScrollNext={canScrollNext} 
  //       scrollPrev={scrollPrev} scrollNext={scrollNext} 
  //     />
  //   </>
  // );
}
